<script lang="ts" setup>
import { AppRawButton, AppSvgIcon } from '@libs/ui';

interface TripOverviewTrashIconButtonProps {
  withBorder: boolean;
  rounded?: boolean;
  ariaLabel: string;
}

const props = defineProps<TripOverviewTrashIconButtonProps>();

interface TripOverviewTrashIconButtonEmits {
  (event: 'remove'): void;
}

const emit = defineEmits<TripOverviewTrashIconButtonEmits>();
</script>

<template>
  <AppRawButton
    :class="[
      'trip-overview-trash-icon-button',
      {
        'with-border': props.withBorder,
        rounded: props.rounded && props.withBorder,
      },
    ]"
    :aria-label="props.ariaLabel"
    @click.stop="emit('remove')"
  >
    <AppSvgIcon name="trashCanOutlined" size="18" />
  </AppRawButton>
</template>

<style lang="scss" scoped>
.trip-overview-trash-icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: var(--spacing-8);
  transition: var(--transition-very-short);
  border-radius: var(--border-radius-8);
  color: var(--color-neutral-70);

  @include on-hover {
    background-color: var(--color-neutral-20);
  }

  &.with-border {
    background-color: var(--color-white);
    border-left: 1px solid var(--color-neutral-30);
    border-bottom: 1px solid var(--color-neutral-30);
    border-radius: 0;
    border-bottom-left-radius: var(--border-radius-8);

    &.rounded {
      border-top-right-radius: var(--border-radius-8);
    }
  }
}
</style>
